// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 283 ? "fe680085" : chunkId) + "." + {"56":"a1d07ab71b1284bf","283":"01da374d915db0fa"}[chunkId] + ".js";
};